import script from "./InformeInventarioEstudyoo.vue?vue&type=script&setup=true&lang=js"
export * from "./InformeInventarioEstudyoo.vue?vue&type=script&setup=true&lang=js"

import "./InformeInventarioEstudyoo.vue?vue&type=style&index=0&id=4ef0e7a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef0e7a8"]])

export default __exports__